import { type HTMLAttributes, type ReactNode, useState } from 'react';

import { usePreloadImages } from '@/common/hooks/preload-images';

import { PulseLoading } from '../Animations/PulseLoading/PulseLoading';

import { Navigation } from './Navigation/Navigation';
import { SlideShowContext } from './context';

interface SlideShowProps<T> extends HTMLAttributes<HTMLDivElement> {
  list: T[];
  render: (props: T) => ReactNode;
  preloading?: {
    list: string[] | [string, string][];
  };
}

const SlideShow = <T extends object>({
  list,
  render,
  preloading,
  ...props
}: SlideShowProps<T>): JSX.Element => {
  const [activeSlide, setActiveSlide] = useState(0);
  const { isLoading } = usePreloadImages(preloading?.list);

  return (
    <SlideShowContext.Provider
      value={{ setActiveSlide, activeSlide, slidesQuantity: list.length }}
    >
      <div {...props}>
        <Navigation
          length={list.length}
          activeSlide={activeSlide}
          setActiveSlide={setActiveSlide}
        />
        {isLoading ? <PulseLoading /> : render(list[activeSlide])}
      </div>
    </SlideShowContext.Provider>
  );
};

export { SlideShow };
